import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=66baef9c"
import script from "./errorPage.vue?vue&type=script&lang=ts"
export * from "./errorPage.vue?vue&type=script&lang=ts"
import style0 from "./errorPage.vue?vue&type=style&index=0&id=66baef9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports